import type { SidebarToggleButtonProps } from '@apple/ui/layouts/components/sidebar-toggle-button';
import { SidebarToggleButton } from '@apple/ui/layouts/components/sidebar-toggle-button';
import {
	useRightSidebarCollapsed,
	useRightSidebarToggleButtonProps,
} from '@apple/ui/shell/contexts/right-sidebar';

type Props = Omit<SidebarToggleButtonProps, 'collapsed' | 'onClick'> & {
	hideWhen?: 'collapsed' | 'expanded';
};

export function ToggleRightSidebarButton({ hideWhen, ...props }: Props) {
	const { isCollapsed, toggle } = useRightSidebarCollapsed();
	const toggleButtonProps = useRightSidebarToggleButtonProps();
	const shouldHide = hideWhen ? (hideWhen === 'collapsed' ? isCollapsed : !isCollapsed) : false;
	return shouldHide ? null : (
		<SidebarToggleButton
			{...toggleButtonProps}
			{...props}
			collapsed={isCollapsed}
			onClick={toggle}
		/>
	);
}
